import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a78a32994a2793884b9b822a5f18baf7fb from "./generated-48ab26ea-a373-4e6f-b4b7-ff5a3a5a2c9a.json";

import abb7cf0ed77d1062c11e7d9173f12c23eb from "./generated-6131e67f-c8ff-41fe-b76b-eb9bf3cafebb.json";

import a1fbe6b4aaea40fed676f43f41efb90c8b from "./generated-6bb6aad1-2197-4c0c-8766-aa42b617e870.json";

import aa4e0244dbddf120600c0b3b1fb54207fb from "./generated-15e1d267-6c39-4139-94df-6f2803e1082e.json";

import a5cc4b54630b276b739f5d5bd71aa0571b from "./generated-92ee6a28-be8d-48f9-ba12-4a1c6e91d07b.json";

import a95a2d56df9a985d001c3fcf1c639dcccb from "./generated-c4e40cd7-0736-43ae-8475-d8e05344d1b7.json";

import af0efa7c4dad63e4151d02903d56466acb from "./generated-2dfb34d5-8d8b-4478-b943-f32d5c55a73d.json";

import ade6a0eb2a05d50dfc8e9a45cc3aabe76b from "./generated-048f3e34-30b1-4f6d-98b7-9ccf2fb5adeb.json";

import a02c179ec0f92dbd11251ee449c5847c6b from "./generated-685c782e-7bf7-491b-892e-14e1c0177ac9.json";

import aa4a16c7f39de09ed35f9dda349e30d6ab from "./generated-0c620305-b256-4816-af8e-d55334a8b344.json";

import adefb8475c9f908f01f403acbdbdb494cb from "./generated-ad193d50-4316-409a-ae0c-6d386989b588.json";

import af251a435979b86d518d5acf7345fea62b from "./generated-d3a56801-ca06-475c-ab1c-02a19db9a652.json";

import a16c8c1177fbf818492811e1a3461721db from "./generated-f3fdf5c0-5b57-4f82-9609-49c5da22faa3.json";

import a17440b6c7d954771c1d6ab423e9e8b1cb from "./generated-30d18eff-4723-4e86-a502-55dcf748374c.json";

import afa9ba9b953765767e9005bcc64d8115cb from "./generated-f0d64bf1-9569-4d3b-8564-183754b09a8a.json";

import ac1ac4661306b9c4bf554eabc4bba0c2bb from "./generated-dffb32e5-df0b-4250-9ba8-fb3e049e8bf4.json";

import a479c969fa5b7c634ef8db8226a4b6ca7b from "./generated-b2b3962e-cb19-4fdb-aadf-7523f4669d70.json";

import afdbc240a3d3f29cd2dc3c6f5eaf2bcd9b from "./generated-c2e6da0d-9568-40db-8b9e-39ab7702a602.json";

import abcf7c883b08b4129e01f3d92bd59d914b from "./generated-61651f66-012b-48cd-880d-92834d5ea950.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a78a32994a2793884b9b822a5f18baf7fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abb7cf0ed77d1062c11e7d9173f12c23eb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a1fbe6b4aaea40fed676f43f41efb90c8b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aa4e0244dbddf120600c0b3b1fb54207fb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a5cc4b54630b276b739f5d5bd71aa0571b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a95a2d56df9a985d001c3fcf1c639dcccb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(af0efa7c4dad63e4151d02903d56466acb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ade6a0eb2a05d50dfc8e9a45cc3aabe76b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a02c179ec0f92dbd11251ee449c5847c6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aa4a16c7f39de09ed35f9dda349e30d6ab);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(adefb8475c9f908f01f403acbdbdb494cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(af251a435979b86d518d5acf7345fea62b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a16c8c1177fbf818492811e1a3461721db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a17440b6c7d954771c1d6ab423e9e8b1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(afa9ba9b953765767e9005bcc64d8115cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac1ac4661306b9c4bf554eabc4bba0c2bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a479c969fa5b7c634ef8db8226a4b6ca7b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(afdbc240a3d3f29cd2dc3c6f5eaf2bcd9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(abcf7c883b08b4129e01f3d92bd59d914b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a479c969fa5b7c634ef8db8226a4b6ca7b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */